import { useTranslation } from '@/i18n/useTranslation';

export function LanguageToggle() {
  const { language, setLanguage, preferenceUnavailable, t } = useTranslation();
  const target = language === 'en' ? 'ja' : 'en';

  return (
    <div className="language-toggle">
      <button
        type="button"
        className="btn btn--secondary btn--sm"
        aria-label={target === 'ja' ? t('Switch to Japanese') : t('Switch to English')}
        onClick={() => setLanguage(target)}
      >
        <span lang={target}>{target === 'ja' ? '日本語' : 'English'}</span>
      </button>
      {preferenceUnavailable && (
        <small role="status">
          {t('Language preference is unavailable. Your selection applies only to this visit.')}
        </small>
      )}
    </div>
  );
}
